export enum PatientRelease {
    Name = 'PatientRelease',
    SendPatientReleaseResult = 'SendPatientReleaseResult',
    ReceiveReleaseResult = 'ReceiveReleaseResult',
    RemovePatientReleaseResult = 'RemovePatientReleaseResult',
    RemoveReleaseResult = 'RemoveReleaseResult',
}
